import { useWizard } from "react-use-wizard";
import RangeByRegionByFacilityTypeStep from "../../../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";
import buySteps from "../../buySteps";
interface ISelectionByOwnBuyStep_6 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const SelectionByOwnBuyStep_6 = ({
  typeIds,
  selectedPolygonIds,
}: ISelectionByOwnBuyStep_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_5);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_7);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        selectedPolygonIds={selectedPolygonIds ?? []}
        typeIds={typeIds ?? []}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default SelectionByOwnBuyStep_6;
